import { set } from "firebase/database";
import { React, useState, useEffect } from "react";
// import { ReactComponent as LockIcon } from "../assets/B1.svg";
import LockIcon from "../assets/lock.png";
import ModuleOne from "../assets/module-one.png";
import ModuleTwo from "../assets/module-two.png";
// import { ReactComponent as ReactLogo3 } from "../assets/module-2.png";

export default function Badges({ badge1, badge2 }) {
	const [displayBadge1, setDisplayBadge1] = useState(badge1);
	const [displayBadge2, setDisplayBadge2] = useState(badge2);
	const [displayBadge3, setDisplayBadge3] = useState(false);
	const [displayActivities, setDisplayActivities] = useState(false);

	useEffect(() => {
		setDisplayBadge1(badge1);
		setDisplayBadge2(badge2);
	}, [badge1, badge2]);

	const handleClick = (num1, num2) => {
		document.querySelectorAll(".badge").forEach((badge) => {
			if (badge.classList.contains('active')) {
				badge.classList.remove('active');
			}
		})
		document.getElementsByClassName("badge")[num1].classList.add('active')
		const elementActive = document.getElementsByClassName("card-three")[num1];
		const elementHidden = document.getElementsByClassName("card-three")[num2];
		elementHidden.classList.add("disabled");
		elementActive.classList.contains("completed")
			? elementActive.classList.remove("completed")
			: elementActive.classList.remove("disabled");
	};

	// const handleClick1 = () => {
	// 	setDisplayBadge1(!displayBadge1);
	// };
	// const handleClick2 = () => {
	// 	setDisplayBadge2(!displayBadge2);
	// };
	const handleClick3 = () => {
		setDisplayBadge3(!displayBadge3);
	};
	return (
		<>
			<div class="row badges">
				<div className={`badge active ${displayBadge1 === "is_awarded" ? "" : "hidden-in-wallet" }`} onClick={() => handleClick(0, 1)}>
				{/* <img src={LockIcon}></img>  */}
					{displayBadge1 === "is_awarded" ? 
						<img src={ModuleOne}></img> :
						<img src={LockIcon}></img> 
					}
					<p className="badge-name">Module one</p>
				</div>
				<div className={`badge ${displayBadge2 === "is_awarded" ? "" : "hidden-in-wallet" }`} onClick={() => handleClick(1, 0)}>
					{displayBadge2 === "is_awarded" ? 
						<img src={ModuleTwo}></img> :
						<img src={LockIcon}></img> 
					}
					{/* {/* {displayBadge2 === "is_awarded" ? <LockIcon /> : <ModuleTwo />} */}
					<p className="badge-name">Module two</p>
				</div>
				{/* <div className="badge">
					{displayBadge3 === "is_activated" ? (
						<ReactLogo3 />
					) : displayBadge3 === "is_awarded" ? (
						<ReactLogo2 />
					) : (
						<ReactLogo1 />
					)}
				</div> */}
			</div>
		</>
	);
}
